// extracted by mini-css-extract-plugin
export default {"icon":"Select_icon__zL1jc","select":"Select_select__jnLj9","github":"Select_github__S2ziJ","stackoverflow":"Select_stackoverflow__HBrLq"};